import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable()
export class BlobErrorHttpInterceptor implements HttpInterceptor {
  public intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error) => {
        if (
          error instanceof HttpErrorResponse &&
          error.error instanceof Blob &&
          error.error.type === "application/json"
        ) {
          // https://github.com/angular/angular/issues/19888
          // When request of type Blob, the error is also in Blob instead of object of the json data
          return new Promise<any>((_resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event: Event) => {
              try {
                const errorMessage = JSON.parse((event.target as any).result);
                reject(
                  new HttpErrorResponse({
                    error: errorMessage,
                    headers: error.headers,
                    status: error.status,
                    statusText: error.statusText,
                    url: error.url ?? "",
                  }),
                );
              } catch (_event) {
                reject(error);
              }
            };
            reader.onerror = () => {
              reject(error);
            };
            reader.readAsText(error.error);
          });
        }
        return throwError(() => error);
      }),
    );
  }
}
